export default "__VITE_ASSET__jlu37lZR__"